import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import './InstallerPanelTable.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { exportDataTableCsv } from '../../helpers/exportCsv';
import { connect } from 'react-redux';
import 'react-quill/dist/quill.snow.css';
import { FilterService, FilterMatchMode } from 'primereact/api';
import { getSyncFailures } from '../../stores/actions/actions';

interface SyncFailuresProps {
    syncFailures: any[];
    getSyncFailures: () => void;
}

const SyncFailures = ({
    syncFailures,
    getSyncFailures
}: SyncFailuresProps) => {

    const dt = useRef(null);

    const [globalFilter, setGlobalFilter] = useState(null);
    useEffect(() => {
        getSyncFailures();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        systemName: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    const startTimestampTemplate = (rowData: any) => {
        if (!rowData.startTimestamp) {
            return null;
        }
        const timestampDate = new Date(rowData.startTimestamp);
        const dateStr = timestampDate.toLocaleString('sv-SE', { timeZone: 'UTC' }).replace('T', ' ');

        return <div>{dateStr}</div>;
    };

    const endTimestampTemplate = (rowData: any) => {
        if (!rowData.endTimestamp) {
            return null;
        }
        const timestampDate = new Date(rowData.endTimestamp);
        const dateStr = timestampDate.toLocaleString('sv-SE', { timeZone: 'UTC' }).replace('T', ' ');

        return <div>{dateStr}</div>;
    };

    const durationTemplate = (rowData: any) => {
        if (!rowData.durationSeconds) {
            return null;
        }

        const days = Math.floor(rowData.durationSeconds / 86400);
        const hours = Math.floor((rowData.durationSeconds % 86400) / 3600);
        const minutes = Math.floor((rowData.durationSeconds % 3600) / 60);
        const seconds = Math.floor(rowData.durationSeconds % 60);

        const parts = [];
        if (days) parts.push(`${days}d`);
        if (hours) parts.push(`${hours}h`);
        if (minutes) parts.push(`${minutes}m`);
        if (seconds || parts.length === 0) parts.push(`${seconds}s`);

        return parts.join(' ');
    };
    console.log('syncFailures', syncFailures);
    const dataTable = useMemo(() => {
        if (!syncFailures) {
            return null;
        }
        return (
            <div className="card">
                <div className="flex justify-content-end mb-3">
                    <Button label="Export" icon="pi pi-file-export" outlined onClick={() => exportDataTableCsv(dt, 'sync-failures')} />
                </div>

                <DataTable ref={dt} value={syncFailures}
                        dataKey="id"  paginator rows={25} rowsPerPageOptions={[10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} systems" globalFilter={globalFilter} onFilter={(e) => setFilters(e.filters)}
                        filters={filters} filterDisplay="row" stripedRows size='small' resizableColumns sortField="endTimestamp" sortOrder={-1}
                        exportFilename="sync-failures"
                        exportFunction={(e) => e.field === 'durationSeconds' ? (durationTemplate(e.rowData) ?? '') : e.data} >
               <Column 
                    field="systemName" 
                    header="System"
                    sortable
                    filter filterPlaceholder=""
                    showFilterMenu={false}>
                </Column>
                <Column 
                    field="startTimestamp" 
                    header="Start (UTC)"
                    body={startTimestampTemplate}
                    style={{ maxWidth: '200px' }}
                    sortable>               
                </Column>
                <Column 
                    field="endTimestamp" 
                    header="End (UTC)"
                    body={endTimestampTemplate}
                    style={{ maxWidth: '200px' }}
                    sortable>               
                </Column>
                <Column 
                    field="durationSeconds" 
                    header="Duration"
                    body={durationTemplate}
                    style={{ maxWidth: '200px' }}
                    sortable>               
                </Column>
                </DataTable>
            </div>
        );
    }, [syncFailures, filters]);
    return (
        <div>
            {syncFailures && dataTable}
        </div>
    ) 

}


const mapStateToProps = (state) => {
    return {
        syncFailures: state.installer.syncFailures,
    };
};

const actions = {
    getSyncFailures,
};

export default connect(mapStateToProps, actions)(SyncFailures);
